import forOwn from "lodash/forOwn";
import mapValues from "lodash/mapValues";
import uniqBy from "lodash/uniqBy";

export function storeResources(state, resources) {
    forOwn(resources, (typeValue, typeKey) => {
        state.resources[typeKey] = {
            ...state.resources[typeKey],
            ...mapValues(typeValue, (resourceValue, resourceKey) => {
                return {
                    ...state.resources[typeKey][resourceKey],
                    ...resourceValue,
                }
            })
        }
    })
}

export function setEventListing(state, events) {
    state.eventListing = events;
}

export function setGameListing(state, games) {
    state.gameListing = games;
}

export function addToGameListing(state, games) {
    const combined = [
        ...state.gameListing,
        ...games
    ];
    state.gameListing = uniqBy(combined, 'id');
}

export function setFavorite(state, { favorite, athleteId }) {
    state.resources.athletes[athleteId] = {
        ...state.resources.athletes[athleteId],
        favoritesReceived: [favorite],
        skips: []
    };
}

export function favoriteFailed(state, { cachedSkips, athleteId }) {
    state.resources.athletes[athleteId] = {
        ...state.resources.athletes[athleteId],
        favoritesReceived: [],
        skips: cachedSkips
    }
}

export function setSkipped(state, { skip, athleteId }) {
    state.resources.athletes[athleteId] = {
        ...state.resources.athletes[athleteId],
        skips: [skip],
        favoritesReceived: []
    };
}

export function skipFailed(state, { cachedFavoritesReceived, athleteId }) {
    state.resources.athletes[athleteId] = {
        ...state.resources.athletes[athleteId],
        favoritesReceived: cachedFavoritesReceived,
        skips: []
    }
}


export function setGame(state, game) {
    state.game = game;
}
export function setAvailableEventsFilters(state, filters) {
    state.availableEventsFilters = filters;
}

export function setAvailableAthleteTeamFilters(state, filters) {
    state.availableAthleteTeamFilters = filters;
}

export function addEventsFilter(state, filter) {
    state.appliedEventsFilters = [...state.appliedEventsFilters, filter];
}

export function removeEventFilter(state, filter) {
    const newFilters = state.appliedEventsFilters.filter(appliedFilter => {
        return (
            (appliedFilter.type == filter.type && appliedFilter.value !== filter.value) || appliedFilter.type != filter.type
        )
    });

    state.appliedEventsFilters = newFilters;
}

export function clearAllEventFilters(state) {
    state.appliedEventsFilters = [];
}

export function addAthleteTeamFilter(state, filter) {
    state.appliedAthleteTeamFilters = [...state.appliedAthleteTeamFilters, filter];
}

export function removeAthleteTeamFilter(state, filter) {
    const newFilters = state.appliedAthleteTeamFilters.filter(appliedFilter => {
        return (
            (appliedFilter.type == filter.type && appliedFilter.value !== filter.value) || appliedFilter.type != filter.type
        )
    });

    state.appliedAthleteTeamFilters = newFilters;
}

export function clearAllAthleteTeamFilters(state) {
    state.appliedAthleteTeamFilters = [];
}

export function setRecommendedGames(state, games) {
    state.recommendedGames = games;
}

export function enableMobile(state, payload) {
    state.enableMobile = payload;
}

export function removeAllAthleteTeamFilterType(state, type) {
    const newFilters = state.appliedAthleteTeamFilters ? state.appliedAthleteTeamFilters.filter(appliedFilter => {
        return (
            (appliedFilter.type != type)
        )
    }) : [];
    state.appliedAthleteTeamFilters = newFilters;
}

export function setFetchState(state, fetchState) {
    state.fetchState = fetchState;
}

export function setCountFetchState(state, fetchState) {
    state.countFetchState = fetchState;
}

export function setFavIntFetchState(state, fetchState) {
    state.favIntFetchState = fetchState;
}

export function setFilterFetchState(state, fetchState) {
    state.filterFetchState = fetchState;
}

export function toggleTeamListingCollapsedStateLeft(state) {
    state.teamListingCollapsedStateLeft = !state.teamListingCollapsedStateLeft;
}

export function toggleTeamListingCollapsedStateRight(state) {
    state.teamListingCollapsedStateRight = !state.teamListingCollapsedStateRight;
}

export function setGamesScrollY(state, val) {
    state.gamesScrollY = val;
}

export function setEventPaginationPage(state, page) {
    state.pagination.events.current_page = page;
}

export function setGamePaginationPage(state, page) {
    state.pagination.games.current_page = page;
}

export function setEventPaginationData(state, data) {
    state.pagination.events = data;
}

export function setGamePaginationData(state, data) {
    state.pagination.games = data;
}